import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const PurchaseOrderListWrapper = styled.div`
  .action-btn {
    color: ${COLORS.primary_light_blue};
  }
  .add-po-btn {
    text-align: right;
    margin-right: 28px;
  }
`;
